import React from 'react';
import { ProductInventoryListTemplate } from 'themes/modules/product/pages';

class ProductInventoryList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<ProductInventoryListTemplate
				{...this.props}
				change={this.props.productDetailViewStore.change}
				actions={this.props.productDetailViewStore}
				viewStore={this.props.inventoryListViewStore}
			/>
		);
	}
}

export default ProductInventoryList;
